export default __webpack_public_path__ + "static/media/Engagement.7237f446.png";